// Inline, single-colour SVGs so the landing page carries no icon-font weight and
// every glyph inherits `currentColor` from the brand palette.

const base = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.7,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: false,
};

export const IconSearch = (props) => (
  <svg {...base} {...props}>
    <circle cx="11" cy="11" r="6.5" />
    <path d="M20 20l-3.8-3.8" />
  </svg>
);

export const IconCode = (props) => (
  <svg {...base} {...props}>
    <rect x="2.5" y="5.5" width="19" height="13" rx="2" />
    <path d="M6 9v6M9 9v6M12 9v6M15.5 9v6M18 9v6" />
  </svg>
);

export const IconPhoto = (props) => (
  <svg {...base} {...props}>
    <rect x="3" y="4.5" width="18" height="15" rx="2.5" />
    <circle cx="8.5" cy="10" r="1.8" />
    <path d="M3.5 17.5l4.7-4.4a2 2 0 012.8.1l5.4 5.4M14.6 14.2l1.9-1.7a2 2 0 012.8.1l1.2 1.2" />
  </svg>
);

export const IconDocument = (props) => (
  <svg {...base} {...props}>
    <path d="M6 2.8h7.5L19 8.4V21a1.2 1.2 0 01-1.2 1.2H6A1.2 1.2 0 014.8 21V4A1.2 1.2 0 016 2.8z" />
    <path d="M13.3 3v5.2H18.7M8 13h8M8 16.6h5.5" />
  </svg>
);

export const IconWallet = (props) => (
  <svg {...base} {...props}>
    <path d="M3.2 7.6A2.4 2.4 0 015.6 5.2h11a2 2 0 012 2v1.2" />
    <rect x="3.2" y="7.6" width="17.6" height="11.2" rx="2.4" />
    <path d="M20.8 12.2h-3.4a1.9 1.9 0 000 3.8h3.4" />
  </svg>
);

export const IconBolt = (props) => (
  <svg {...base} {...props}>
    <path d="M13.2 2.5L4.8 13.4h6L10.8 21.5l8.4-10.9h-6z" />
  </svg>
);

export const IconShield = (props) => (
  <svg {...base} {...props}>
    <path d="M12 2.6l7.5 3v6.2c0 4.4-3 8.2-7.5 9.6-4.5-1.4-7.5-5.2-7.5-9.6V5.6z" />
    <path d="M8.8 11.9l2.2 2.2 4.2-4.4" />
  </svg>
);

export const IconTruck = (props) => (
  <svg {...base} {...props}>
    <path d="M2.8 6.4h10.4v9.2H2.8zM13.2 9.4h3.6l3.4 3.2v3h-7z" />
    <circle cx="7" cy="17.6" r="1.9" />
    <circle cx="16.6" cy="17.6" r="1.9" />
  </svg>
);

export const IconCart = (props) => (
  <svg {...base} {...props}>
    <path d="M2.8 3.6h2.6l2.2 10.6h9.6l2-7.2H6.4" />
    <circle cx="9.4" cy="19" r="1.7" />
    <circle cx="16.8" cy="19" r="1.7" />
  </svg>
);

export const IconUser = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="8.2" r="3.6" />
    <path d="M4.8 20c.6-3.8 3.6-6 7.2-6s6.6 2.2 7.2 6" />
  </svg>
);

export const IconSend = (props) => (
  <svg {...base} {...props}>
    <path d="M21 3.4L10.6 13.9M21 3.4l-6.6 18-3.8-7.5-7.6-3.8z" />
  </svg>
);

export const IconArrow = (props) => (
  // Points to the left — the "forward" direction in an RTL layout.
  <svg {...base} {...props}>
    <path d="M14.5 5.5L8 12l6.5 6.5" />
  </svg>
);

export const IconCheck = (props) => (
  <svg {...base} {...props}>
    <path d="M4.5 12.6l4.8 4.8L19.5 7.2" />
  </svg>
);

export const IconPlus = (props) => (
  <svg {...base} {...props}>
    <path d="M12 5.5v13M5.5 12h13" />
  </svg>
);

export const IconMenu = (props) => (
  <svg {...base} {...props}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </svg>
);

export const IconClose = (props) => (
  <svg {...base} {...props}>
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

export const IconPhone = (props) => (
  <svg {...base} {...props}>
    <path d="M7.4 3.2h-3a1.6 1.6 0 00-1.6 1.7c.3 3.9 1.9 7.6 4.6 10.3s6.4 4.3 10.3 4.6a1.6 1.6 0 001.7-1.6v-3a1.6 1.6 0 00-1.4-1.6l-2.4-.3a1.6 1.6 0 00-1.6.8l-.7 1.2a13 13 0 01-5.6-5.6l1.2-.7a1.6 1.6 0 00.8-1.6l-.3-2.4a1.6 1.6 0 00-1.6-1.4z" />
  </svg>
);

export const IconClock = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 6.8V12l3.4 2" />
  </svg>
);

export const IconLogin = (props) => (
  <svg {...base} {...props}>
    <path d="M14 3.5h4.3a1.7 1.7 0 011.7 1.7v13.6a1.7 1.7 0 01-1.7 1.7H14" />
    <path d="M9.6 8.2L5.4 12l4.2 3.8M5.6 12H15" />
  </svg>
);

/**
 * Decorative brake-rotor motif for the hero background — stroke-only vector, so
 * it scales and tints with the palette instead of dragging in a stock photo.
 */
export const RotorMark = (props) => {
  const holes = Array.from({ length: 12 }, (_, i) => {
    const angle = (i / 12) * Math.PI * 2;
    return { cx: 100 + Math.cos(angle) * 62, cy: 100 + Math.sin(angle) * 62 };
  });
  const vanes = Array.from({ length: 24 }, (_, i) => {
    const angle = (i / 24) * Math.PI * 2;
    return {
      x1: 100 + Math.cos(angle) * 78,
      y1: 100 + Math.sin(angle) * 78,
      x2: 100 + Math.cos(angle) * 92,
      y2: 100 + Math.sin(angle) * 92,
    };
  });

  return (
    <svg
      viewBox="0 0 200 200"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <circle cx="100" cy="100" r="95" />
      <circle cx="100" cy="100" r="78" />
      <circle cx="100" cy="100" r="42" />
      <circle cx="100" cy="100" r="30" />
      <circle cx="100" cy="100" r="9" />
      {holes.map((hole, i) => (
        <circle key={i} cx={hole.cx} cy={hole.cy} r="5" />
      ))}
      {vanes.map((vane, i) => (
        <line key={i} x1={vane.x1} y1={vane.y1} x2={vane.x2} y2={vane.y2} />
      ))}
      {[0, 1, 2, 3, 4].map((i) => {
        const angle = (i / 5) * Math.PI * 2;
        return (
          <circle key={`bolt-${i}`} cx={100 + Math.cos(angle) * 20} cy={100 + Math.sin(angle) * 20} r="3.5" />
        );
      })}
    </svg>
  );
};

export const IconGlobe = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3.2 12h17.6M12 3a15 15 0 010 18M12 3a15 15 0 000 18" />
  </svg>
);
